import React from 'react'
import Header from '../../../../shared/sections/Header'
import Annotation from '../../../../shared/sections/FirstView/Annotation'
import { okinawaConfig } from '../../config'
import styles from './OkinawaSpLandingPage.module.css'
import VerticalEntryForm from '../../../../shared/forms/VerticalEntryForm'
import { StepProvider } from '@/components/Context/StepContext'
import { OkinawaSpLandingPageProps } from './types'
import { useJobsData } from '../../../../shared/hooks/useJobsData'
import { useConfigWithDynamicData } from '../../../../shared/hooks/useConfigWithDynamicData'
import { useAbTestGtm } from '@/components/utils/abTest'
import { SlimFirstView } from '@/components/Common/SlimFirstView'
import { CompanyLogoStrip } from '@/components/Common/CompanyLogoStrip'
import Footer from '../../../../shared/sections/Footer/Footer'

const OkinawaSpLandingPage: React.FC<OkinawaSpLandingPageProps> = ({ prefectures }) => {
    const { dataViewLabel } = useAbTestGtm()

    const { jobs, mapping, error } = useJobsData(okinawaConfig)

    const configWithDynamicData = useConfigWithDynamicData({
        areaConfig: okinawaConfig,
        jobs,
        mapping
    })

    if (error) {
        console.error('求人データの読み込みエラー:', error)
    }

    return (
        <div className={styles.okinawaSpLandingPage}>
            <StepProvider
                initialFormData={{
                    preferLineContact: true,
                    agreeTerms: true
                }}
                initialTouchedFields={{
                    preferLineContact: true,
                    agreeTerms: true,
                    channel: true
                }}
            >
                <Header
                    id='renewal_top'
                    dataViewLabel={dataViewLabel('HD')}
                />
                <SlimFirstView dataViewLabel={dataViewLabel('CT_FirstView')} />
                <CompanyLogoStrip />
                <VerticalEntryForm
                    prefectures={prefectures}
                    config={configWithDynamicData}
                />
                <Annotation />
                <Footer />
            </StepProvider>
        </div>
    )
}

export default OkinawaSpLandingPage
